module.exports = __webpack_public_path__ + "img/banner_promocode.82880705.png";